import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import StaffContainer from './styles';
import { Typography } from '@material-ui/core';
import LabelTitle from '../../../../components/Titles/LabelTitle';
import { useTranslation } from 'react-i18next';
import Teachers from './Teachers';
import Directors from './Directors';
import Tab from '../../../../components/Tab';
import Animation from '../../../../components/Animation';
import { scrollToDirectionSelector } from '../../selectors';

const Staff = props => {
	const ref = useRef(null);
	const { t } = useTranslation();
	useEffect(() => {
		if (props.scrollToDirection) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}, [props.scrollToDirection]);

	return (
		<StaffContainer ref={ref}>
			<Animation animateIn="fadeInDown">
				<LabelTitle content={t('general.staff.label')} />
				<Typography variant="h2" color="textSecondary">
					{t('general.staff.title')}
				</Typography>
			</Animation>
			<Tab
				items={[
					{
						label: t('general.staff.directors.title'),
						component: <Directors />
					},
					{ label: t('general.staff.teachers.title'), component: <Teachers /> }
				]}
			/>
		</StaffContainer>
	);
};

const mapStateToProps = state => {
	return {
		scrollToDirection: scrollToDirectionSelector(state)
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Staff);
